<mat-tab-group class="porto_tabs" (selectedTabChange)="onTabClick($event)">
  <mat-tab *ngFor="let day of portoLeaderBoards;let board_index=index">
    <ng-template mat-tab-label>
      <!--<i class="icon-knockout"></i>-->
      {{day?.tournament_name}}
    </ng-template>
    <!--<div class="spacer md"></div>-->
    <div *ngIf="!loadingLeaderBoards;else loadboards">
      <div class="group_container" *ngFor="let group of day?.groups?.data">
        <ul>
          <div class="group_items">
            <h1>{{group.group_name}}</h1>
            <p style="display: inline-block">{{group.note}}</p>
          </div>
          <ul class="group_items">
            <div class="flex_items">
              <li class="col-xs-1">#</li>
              <li class="col-sm-3 col-xs-3">GAMER / Team
              </li>
              <li class="col-sm-2 hidden-xs">Game #</li>
              <div class="hidden-lg hidden-md hidden-sm  col-xs-1">R
              </div>
              <li class="col-sm-2 hidden-xs">Kills</li>
              <div class="hidden-lg hidden-md hidden-sm  col-xs-1">K
              </div>
              <li class="col-sm-2 hidden-xs">Damage</li>
              <div class="hidden-lg hidden-md hidden-sm col-xs-2">D
              </div>
              <li class="col-sm-2 hidden-xs">Points</li>
              <div class="hidden-lg hidden-md hidden-sm col-xs-2">P
              </div>

            </div>
          </ul>

          <ul class="group_items"
              *ngFor="let participant of group.participants.data | participantSort:'AllInOne':false|limitNgFor:5;let index=index">
            <div class="flex_items">
              <li class="col-xs-1">{{index + 1}}</li>
              <li
                (click)="openParticipantProfile(profileService.participant_type,
                 participant.participant_name,
                  participant.participant_id)"
                class="col-sm-3 col-xs-3 pointer">
                <img [src]="participant.avatar" alt="{{participant.participant_name}}">{{participant.participant_name
                |truncate:15}}
              </li>
              <li class="col-sm-2 col-xs-1 pubg_input_container" *ngIf="participant.game_ranks">
                <div *ngFor="let rank of participant.game_ranks">
                  {{rank ? rank : 0}}
                </div>
              </li>
              <li class="col-sm-2 col-xs-1 pubg_input_container" *ngIf="participant.kills">
                <div *ngFor="let kill of participant.kills">
                  {{kill ? kill : 0}}
                </div>
              </li>
              <li class="col-sm-2 col-xs-2 pubg_input_container" *ngIf="participant.damage_rate">
                <div *ngFor="let rate of participant.damage_rate">
                  {{rate ? rate : 0}}
                </div>
              </li>
              <li class="col-xs-2">{{participant.score ? participant.score : 0}}</li>
            </div>
            <div class="team_leader_item" *ngIf="participant.leader">
              <div class="text">
                <!--<i class="icon-star" style="color:gold"></i>-->
                <img [src]="participant.leader?.avatar" width="30" alt=""> {{participant.leader?.username
                |truncate:25}}
              </div>
            </div>
          </ul>
          <ul *ngIf="group.participants?.data?.length==0">
            <div class="block">
              <div class="big_block " style="background-color: #45274f;">
                <div class="content text-center">
                  <p>No participants have joined yet.</p>
                </div>
              </div>
            </div>
          </ul>

        </ul>
      </div>
    </div>
    <ng-template #loadboards>
      <app-loading-indicator></app-loading-indicator>
    </ng-template>
  </mat-tab>
</mat-tab-group>



